import { useNotification } from '@kyvg/vue3-notification'
import capitaliseFirstLetter from '../helpers/capitaliseFirstLetter'
import handleError from '../helpers/handleError'
import store from '../store/index'
//-------------------
// show notification
//-------------------
export default async function showNotification(msg, options = {}) {
  const notification = useNotification()
  const config = store.getters['combat/getConfig']
  const notificationMessage = typeof msg === 'string' ? capitaliseFirstLetter(msg) : msg
  const duration =
    typeof options?.duration === 'number' && options.duration >= 0 ? options.duration : 2000
  const speed = typeof options?.speed === 'number' && options.speed >= 0 ? options.speed : 600
  const shouldLog = options?.log !== false

  console.log('show notification = ', msg)
  //--------------------------------
  // display notification on screen
  //--------------------------------
  notification.notify({
    group: 'bb-confirm',
    // title: "Important message",
    text: notificationMessage,
    closeOnClick: true,
    ignoreDuplicates: true,
    duration,
    speed,
  })
  //---------------------------
  // write notification to log
  //---------------------------
  if (shouldLog && config?.log_notifications) {
    const arena = store.getters['combat/getCampaign']
    if (!arena?.id) {
      return
    }
    //-------------
    // set payload
    //-------------
    let payload = {
      arena: arena.id,
      description: notificationMessage,
    }
    //-------------
    // create log
    //-------------
    store
      .dispatch('combat/createCampaignLog', payload)
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        handleError(err)
      })
  }
}
